import { Component, OnInit } from '@angular/core';
import { URLS } from 'src/app/constants/URLS';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  channelUrl: string = URLS.channelUrl;
  channelIdCache = '';

  constructor() { 
    this.channelIdCache = localStorage.getItem('wl_content_provider_id') || '';
  }

  ngOnInit() {
  }

}
